import { formatTime, useMediaState } from '@vidstack/react';
import { useVideoPlayerContext } from '../../player-context';

export const CurrentTimeDuration = () => {
  const { playerRef } = useVideoPlayerContext();
  const currentTime = useMediaState('currentTime', playerRef!);
  const duration = useMediaState('duration', playerRef!);
  const isFullscreen = useMediaState('fullscreen', playerRef!);

  return (
    <div className="flex items-center justify-center h-[32px]">
      <span
        className={`text-text-primary flex-shrink-0 font-[var(--font-weight-bold)] leading-[var(--line-height-18)] ${isFullscreen ? 'text-[14px]' : 'text-[12px]'}`}
      >
        {formatTime(currentTime)} / {formatTime(duration)}
      </span>
    </div>
  );
};
